import styled from 'styled-components';


export const UploadWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto;
`;

export const UploadText = styled.h4`
  margin: 10px 0 0 0;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 22px;
  text-align: center;
  color: ${({ theme }) => theme.colors.gullGray};
  display: flex;
`;



// WEBPACK FOOTER //
// ./src/components/attachments/list/styled-components.js